import DialogContent from '@zenbusiness/zui/DialogContent';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

const FormWrapperStyle = ({ theme }) => ({
  padding: '40px 0 100px 0',
  [theme.breakpoints.up('md')]: {
    padding: '60px 0 100px 0'
  }
});

const WrapperStyle = ({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '4 / 10'
  }
});

export const DialogContentStyled = styled(DialogContent)(FormWrapperStyle);
export const Wrapper = styled(Stack)(WrapperStyle);
